import {
	FormControl,
	FormLabel,
	Grid,
	Input,
	Select,
	Switch,
	Textarea,
	VStack,
} from "@msuite/picasso";
import type { FC } from "react";
import { useFormContext } from "react-hook-form";
import { type AddPlanningRequestFormType, FormError } from "./schema";

export const AddPlanningRequestForm: FC = () => {
	/** Context */
	const methods = useFormContext<AddPlanningRequestFormType>();

	/** Render */
	return (
		<VStack paddingBottom="10vh">
			<FormControl>
				<FormLabel>Typ</FormLabel>
				<Select
					value="AP"
					placeholder="Select..."
					isDisabled
				>
					<option value="AP">Ausführungsplanung</option>
				</Select>
			</FormControl>
			<FormControl>
				<FormLabel>Projekt</FormLabel>
				<Input
					{...methods.register("projectName")}
					placeholder="z.B.: Musterbaustelle"
				/>
				<FormError name="projectName" />
			</FormControl>
			<Grid
				gridTemplateColumns="1fr 1fr"
				gap={6}
			>
				<FormControl>
					<FormLabel>Auftraggeber</FormLabel>
					<Input
						{...methods.register("auftraggeber")}
						placeholder="z.B.: Muster GmbH"
					/>
					<FormError name="auftraggeber" />
				</FormControl>
				<FormControl>
					<FormLabel>Projektnummer</FormLabel>
					<Input
						{...methods.register("projectNumber")}
						placeholder="z.B.: 2214832"
					/>
					<FormError name="projectNumber" />
				</FormControl>
			</Grid>
			<FormControl>
				<FormLabel>Adresse, PLZ, Ort</FormLabel>
				<Input
					{...methods.register("address")}
					placeholder="z.B.: Musterstraße 1, 12345 Musterstadt"
				/>
				<FormError name="address" />
			</FormControl>
			<FormControl>
				<FormLabel>Fälligkeitsdatum</FormLabel>
				<Input
					type="date"
					{...methods.register("dueAt")}
				/>
				<FormError name="dueAt" />
			</FormControl>
			<Switch {...methods.register("statik")}>Statik erstellen lassen ?</Switch>
			<Switch {...methods.register("planunterlagen")}>Planunterlagen vorhanden</Switch>
			<FormControl>
				<FormLabel>Anforderungen</FormLabel>
				<Textarea
					{...methods.register("anforderungen")}
					placeholder="z.B.: Besondere Anforderungen an die Planung"
				/>
				<FormError name="anforderungen" />
			</FormControl>
			<FormControl>
				<FormLabel>Sonstiges</FormLabel>
				<Textarea
					{...methods.register("sonstiges")}
					placeholder="z.B.: Sonstige Hinweise"
				/>
				<FormError name="sonstiges" />
			</FormControl>
		</VStack>
	);
};
